import React from 'react';
import PropTypes from 'prop-types';

export const CountdownRenderer = ({ minutes, seconds }) => {
  const formattedSeconds = seconds < 10 ? `0${seconds}` : `${seconds}`;
  const formattedMinutes = minutes < 10 ? `0${minutes}` : `${minutes}`;
  return (
    <span data-testid='countdown-time'>{`${formattedMinutes}:${formattedSeconds}`}</span>
  );
};

CountdownRenderer.propTypes = {
  minutes: PropTypes.number.isRequired,
  seconds: PropTypes.number.isRequired,
};
